import React from "react";
import { FormSelectProps } from "./form-select.types";
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/dentlab/src/components/ui/select";

export const FormSelectDropdown: React.FC<FormSelectProps> = ({
	orgId,
	forms,
	selection,
	onFormSelect,
}) => {
	const handleSelect = (value: string) => {
		onFormSelect(orgId, value);
	};

	return (
		<Select onValueChange={handleSelect}>
			<SelectTrigger className="w-[180px]">
				<SelectValue placeholder="Formular auswählen" />
			</SelectTrigger>
			<SelectContent>
				<SelectGroup>
					{forms?.map((form) => (
						<SelectItem key={form.id} value={form.id}>
							{form.title}
						</SelectItem>
					))}
				</SelectGroup>
			</SelectContent>
		</Select>
	);
};
